// Demo mode — its routes, pages and MSW mocks — only ever runs on local,
// staging and review hosts. It must never be reachable by customers in
// production, so this gate guards both mounting the demo and registering its
// routes.
const ALLOWED_DEMO_HOSTS = ['localhost', 'stage.iwoca-dev.co.uk'];

export function isDemoHostAllowed(): boolean {
  const { hostname } = window.location;
  return (
    ALLOWED_DEMO_HOSTS.includes(hostname) ||
    hostname.endsWith('.review.iwoca-dev.co.uk')
  );
}
